function PageContent({ children, className = "" }) {
  return (
    <div className={`page-content ${className}`.trim()}>
      {children}
    </div>
  );
}

export default PageContent;
